const EmeraldDiamond = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M82.03,12.7c-0.01-0.05-0.01-0.09-0.03-0.13c-0.01-0.04-0.03-0.07-0.06-0.1c-0.02-0.03-0.02-0.06-0.04-0.08
	c-0.01-0.01-0.02-0.01-0.03-0.02c-0.01-0.01-0.01-0.02-0.02-0.03l-7.48-7.06c-0.01-0.01-0.02-0.01-0.02-0.02
	c-0.01-0.01-0.01-0.01-0.02-0.02c-0.02-0.02-0.05-0.02-0.07-0.03c-0.04-0.02-0.07-0.04-0.12-0.06c-0.04-0.01-0.07-0.02-0.11-0.02
	c-0.03,0-0.05-0.02-0.08-0.02H26.04c-0.03,0-0.05,0.01-0.08,0.02c-0.04,0-0.07,0.01-0.11,0.02c-0.04,0.01-0.08,0.04-0.12,0.06
	c-0.02,0.01-0.05,0.02-0.07,0.03c-0.01,0.01-0.01,0.01-0.02,0.02c-0.01,0.01-0.02,0.01-0.02,0.02l-7.48,7.06
	c-0.01,0.01-0.01,0.02-0.02,0.03c-0.01,0.01-0.02,0.01-0.03,0.02c-0.02,0.02-0.03,0.05-0.04,0.08c-0.02,0.03-0.04,0.06-0.06,0.1
	c-0.02,0.04-0.02,0.08-0.03,0.13c0,0.03-0.02,0.05-0.02,0.08v74.44c0,0.03,0.01,0.05,0.02,0.08c0.01,0.04,0.01,0.09,0.03,0.13
	c0.01,0.04,0.04,0.07,0.06,0.1c0.02,0.03,0.02,0.06,0.04,0.08c0.01,0.01,0.02,0.01,0.02,0.02c0.01,0.01,0.01,0.02,0.02,0.03
	l7.48,7.06c0.01,0.01,0.02,0.01,0.02,0.02c0.01,0.01,0.01,0.01,0.02,0.02c0.03,0.02,0.06,0.04,0.1,0.05
	c0.02,0.01,0.04,0.03,0.07,0.04c0.07,0.03,0.14,0.04,0.21,0.04c0,0,0,0,0,0s0,0,0,0h47.92c0.07,0,0.14-0.01,0.21-0.04
	c0.02-0.01,0.04-0.02,0.07-0.04c0.03-0.02,0.07-0.03,0.1-0.05c0.01-0.01,0.01-0.01,0.02-0.02c0.01-0.01,0.02-0.01,0.02-0.02
	l7.48-7.06c0.01-0.01,0.01-0.02,0.02-0.03c0.01-0.01,0.02-0.01,0.03-0.02c0.02-0.02,0.03-0.05,0.04-0.08
	c0.02-0.03,0.04-0.06,0.06-0.1c0.02-0.04,0.02-0.09,0.03-0.13c0-0.03,0.02-0.05,0.02-0.08V12.78C82.04,12.75,82.03,12.73,82.03,12.7
	z M74.03,93.4l-3.21-4.07l5.76-5.44l3.96,3.35L74.03,93.4z M27.28,93.69l3.01-3.81h39.43l3.01,3.81H27.28z M19.46,87.25l3.96-3.35
	l5.76,5.44l-3.21,4.07L19.46,87.25z M19.16,14.07l3.69,3.12v65.62l-3.69,3.12V14.07z M25.97,6.6l3.21,4.07l-5.76,5.44l-3.96-3.35
	L25.97,6.6z M72.72,6.31l-3.01,3.81H30.29l-3.01-3.81H72.72z M80.54,12.75l-3.96,3.35l-5.76-5.44l3.21-4.07L80.54,12.75z
	 M75.96,81.79l-3.69-3.12V21.33l3.69-3.12V81.79z M31.23,88.67l3.01-3.81h31.51l3.01,3.81H31.23z M24.04,18.21l3.69,3.12v57.34
	l-3.69,3.12V18.21z M68.77,11.33l-3.01,3.81H34.24l-3.01-3.81H68.77z M71.07,78.69l-5.26,4.97H34.19l-5.26-4.97V21.31l5.26-4.97
	h31.62l5.26,4.97V78.69z M71.69,20.24l-4.83-4.56l3.21-4.07l5.59,5.28L71.69,20.24z M33.14,15.68l-4.83,4.56l-3.96-3.35l5.59-5.28
	L33.14,15.68z M28.31,79.76l4.83,4.56l-3.21,4.07l-5.59-5.28L28.31,79.76z M66.86,84.32l4.83-4.56l3.96,3.35l-5.59,5.28L66.86,84.32
	z M77.16,82.81V17.19l3.69-3.12v71.85L77.16,82.81z"
      />
    </svg>
  )
}

export default EmeraldDiamond
